<!--CONTRATO DE APERTURA DE CRÉDITO CON GARANTÍA PRENDARIA (AUTOMOVIL) - PERSONA FISICA-->
<template>
    <div class="page-simulator">
        <form class="form-inline contract-container single-page-mode" @submit.prevent="handleSubmit">
            <div class="content-ref" ref="contractContent">

                <!-- Contenedor principal que simula el papel -->

                <!-- Page 1 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->

                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                        <div class="contract-title text-uppercase">
                                            <p>
                                                <strong>CONTRATO DE APERTURA DE CRÉDITO SIMPLE CON INTERÉS,</strong> CUYO NÚMERO DE IDENTIFICACIÓN SE INDICA EN LA 
                                                CARÁTULA BAJO EL RUBRO “NÚMERO DE CONTRATO”, QUE CELEBRAN POR UNA PARTE LA SOCIEDAD <strong>KVF GROUP, S.A. DE 
                                                C.V.</strong>, RECONOCIDA COMO EL ACREDITANTE, A QUIEN EN LO SUCESIVO SE LE DENOMINARÁ COMO <strong>“GOLDBERGFUND”</strong>, Y 
                                                POR OTRA PARTE LA PERSONA FÍSICA CUYO NOMBRE SE INDICA EN LA CARÁTULA DEL PRESENTE CONTRATO, RECONOCIDA 
                                                COMO EL ACREDITADO, EN LO SUCESIVO <strong>“EL ACREDITADO”</strong>, Y LA PERSONA MORAL O FÍSICA CUYA DENOMINACIÓN, RAZÓN 
                                                SOCIAL O NOMBRE RESPECTIVAMENTE, SE INDICAN EN LA CARÁTULA DEL PRESENTE CONTRATO, RECONOCIDO COMO EL 
                                                OBLIGADO SOLIDARIO, EN LO SUCESIVO <strong>“EL OBLIGADO SOLIDARIO”</strong>, QUIENES SE SUJETAN AL TENOR DE LAS SIGUIENTES 
                                                DECLARACIONES Y CLÁUSULAS: 
                                            </p>
                                        </div>
                                    </div>

                                    <div class="section-title text-uppercase">DECLARACIONES:</div>
                                    <div class="title-clausula-exception">
                                        <strong>
                                            I.- Declara GOLDBERGFUND, por conducto de su representante legal, y bajo protesta de decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Que está legalmente constituida conforme a las leyes mexicanas según consta en la Escritura Pública número 235 
                                        con fecha diez de febrero de dos mil dieciséis, pasada ante la fe del Lic. Gabriela Alejandra González López, Notario 
                                        Público número 82 en el Estado de Quintana Roo; 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que su representada le otorgó facultades suficientes para comparecer a la celebración del presente contrato, mismas que a la                         fecha no le han sido revocadas, modificadas o restringidas de forma alguna. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong> Para todos los efectos del presente contrato, señala como domicilio para oír y recibir notificaciones el ubicado en 
                                        Calle Robert Schumann, Número 4898, Colonia Lomas del Seminario, Zapopan, Jalisco, C.P 45038. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong> Que es su deseo celebrar el presente contrato con <strong>EL ACREDITADO</strong> y el <strong>OBLIGADO SOLIDARIO</strong> en virtud de contar 
                                        con la capacidad y experiencia necesaria para el cumplimiento del presente contrato en los términos y condiciones que 
                                        más adelante se indican.
                                    </div>

                                    <div class="title-clausula">
                                        <strong>
                                            II.- Declara EL ACREDITADO, por su propio y personal derecho, y bajo protesta de decir verdad que: 
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Es una persona física, mayor de edad, con plena capacidad para contratar y obligarse con los términos de este
                                        contrato. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que tanto la información y los datos generales proporcionados en la carátula del presente contrato (Anexo A) y 
                                        consignada como los datos patrimoniales que ha entregado con anterioridad a <strong>GOLDBERGFUND</strong> son verdaderos, y que 
                                        presentan de manera exacta y fiel su situación financiera al momento de la firma del presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong>  Para todos los efectos del presente contrato, señala como domicilio para oír y recibir notificaciones el señalado en 
                                        la carátula de este contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong> Tener la debida capacidad jurídica y económica para
                                        contratar y
                                        obligarse en los términos del presente contrato, no
                                        se tiene ninguna limitación legal, contractual, de alguna autoridad judicial o
                                        administrativa, o de cualquier otra índole
                                        para celebrar el presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>e)</strong> Los recursos que utilizará para pagar las obligaciones
                                        derivadas
                                        del presente contra no son, ni serán de procedencia
                                        ilícita.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>f)</strong> Es su voluntad celebrar el presente contrato, en los
                                        términos y
                                        bajo las condiciones que el mismo establece.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>g)</strong> Que <strong>GOLDBERGFUND</strong> le hizo del conocimiento
                                        antes
                                        de la firma de este contrato: Su contenido, tasa de interés
                                        ordinario, moratorio, comisiones, seguros o gastos que se generarán por la
                                        celebración del presente contrato.
                                    </div>
                                    <div class="declaration-item">
                                        <strong>h)</strong> Que <strong>GOLDBERGFUND</strong> le explico el CAT
                                        reflejado en la carátula del contrato.
                                    </div>

                                    <div class="title-clausula">
                                        <strong>
                                            III.- Declara EL OBLIGADO SOLIDARIO, bajo protesta de decir verdad que:
                                        </strong>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>a)</strong> Los datos generales son y corresponden a los que han quedado señalados en la carátula del presente, la cual es 
                                        presentada como Anexo A y en los formatos de identificación establecidos por <strong>GOLDBERGFUND</strong> es: (i) una persona 
                                        física, mayor de edad con plena capacidad para contratar y obligarse con los términos de este contrato, o (ii) una 
                                        persona moral debidamente constituida y existente conforme a las leyes de México y que su representante en este 
                                        acto cuenta con las facultades suficientes para contratar y obligar a su representada en los términos de este contrato, 
                                        mismas facultades que a la fecha no le han sido modificadas, limitadas o revocadas en forma alguna, encontrándose 
                                        debidamente inscritas en el Registro Público de la Propiedad y de Comercio. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>b)</strong> Que tanto la información proporcionada en la carátula del presente contrato (Anexo A) y consignada como los datos 
                                        patrimoniales que ha entregado con anterioridad a <strong>GOLDBERGFUND</strong> son verdaderos, que presentan de manera exacta 
                                        y fiel su situación financiera al momento de la firma del presente contrato. 
                                    </div>
                                </div>
                            </slot>

                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 2 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->

                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="declaration-item">
                                        <strong>c)</strong> Tener la debida capacidad jurídica y económica para contratar y obligarse en los términos del presente contrato, no 
                                        se tiene ninguna limitación legal, contractual, de alguna autoridad judicial o administrativa, o de cualquier otra índole 
                                        para celebrar el presente contrato. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>d)</strong>  Los recursos que utilizarán para pagar las obligaciones derivadas del presente contrato no son ni serán de 
                                        procedencia ilícita. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>e)</strong> Es su voluntad celebrar el presente contrato y constituirse como <strong>OBLIGADO SOLIDARIO</strong>, y, en consecuencia, obligarse 
                                        con <strong>GOLDBERGFUND</strong> respecto del cumplimiento de todas y cada una de las obligaciones a cargo de <strong>EL ACREDITADO</strong>, 
                                        de conformidad a los términos y condiciones del presente contrato. 
                                    </div>
                                    <div class="declaration-item">
                                        <strong>f)</strong> Manifiesta que, previamente a la celebración del presente contrato <strong>GOLDBERGFUND</strong> le informó las obligaciones que 
                                        asume por comparecer con el carácter de <strong>OBLIGADO SOLIDARIO</strong> a la celebración del presente contrato, enfatizando 
                                        que, <strong>GOLDBERGFUND</strong> podrá, exigirle directamente el cumplimiento de las obligaciones derivadas del presente 
                                        contrato, sin necesidad de agotar el cobro primeramente a <strong>EL ACREDITADO</strong>.
                                    </div>

                                    <div class="title-clausula-list" style="margin-top: 10px !important; margin-bottom: 10px !important;">
                                        <strong>
                                            IV.- Declaran GOLDBERGFUND, EL ACREDITADO y EL OBLIGADO SOLIDARIO, bajo protesta de decir verdad: 
                                        </strong>
                                    </div>
                                    <div class="list-declaration">
                                        <ol type="a" class="list-text custom-alpha">
                                            <li class="list-letter list-letter-normal">
                                                <span class="list-title">Que para efectos del presente contrato acuerdan las siguientes definiciones:</span>

                                                <ol class="custom-number">
                                                    <li class="sublist-number">
                                                        <strong>Contrato:</strong> Documento presente por medio del cual se establecen los términos y condiciones a las que se obligan 
                                                        las partes, que en conjunto con la carátula y anexos forman un mismo documento
                                                    </li>
                                                    <li>
                                                        <strong>Carátula:</strong> Documento que forma parte integrante de este contrato como el Anexo “A”, en lo sucesivo la carátula, 
                                                        donde se expresan los datos generales de <strong>EL ACREDITADO, GOLDBERGFUND, OBLIGADO SOLIDARIO</strong>, así como 
                                                        las características que rigen al presente contrato.
                                                    </li>
                                                    <li>
                                                        <strong>Obligado Solidario:</strong> Persona Física o Moral, que se obliga mediante su firma a liquidar las obligaciones de pago 
                                                        derivadas del presente contrato en caso de incumplimiento de <strong>EL ACREDITADO</strong>, o bien en caso de que 
                                                        <strong>GOLDBERGFUND</strong> estime de buena fe que hay riesgo que <strong>EL ACREDITADO</strong> no liquide las obligaciones de pago, 
                                                        debido a que incumpla con una o más obligaciones del presente contrato, o bien porque cambien las 
                                                        circunstancias bajo las cuales firma el contrato <strong>EL ACREDITADO</strong>. 
                                                    </li>
                                                    <li>
                                                        <strong>Interés Ordinario:</strong> Cantidad expresada en términos porcentuales anuales, que <strong>EL ACREDITADO</strong>, o en su caso <strong>EL 
                                                        OBLIGADO SOLIDARIO</strong> está obligado a pagar a <strong>GOLDBERGFUD</strong>, por poner a disposición del <strong>ACREDITADO</strong> un 
                                                        monto en pesos. 
                                                    </li>
                                                    <li>
                                                        <strong>Interés Moratorio:</strong> Cantidad expresada en términos porcentuales que <strong>EL ACREDITADO</strong>, o en su caso <strong>EL OBLIGADO 
                                                        SOLIDARIO</strong>, está obligado a pagar a <strong>GOLDBERGFUND</strong> por el pago tardío.
                                                    </li>
                                                    <li>
                                                        <strong>CAT:</strong> Costo total del financiamiento del presente contrato, expresado en términos porcentuales anuales, para 
                                                        fines informativos y de comparación, incorpora la totalidad de los costos y gastos inherentes a este contrato.
                                                    </li>
                                                    <li>
                                                        <strong>Pago Anticipado:</strong> Pago parcial o total del saldo insoluto de un contrato, antes de la fecha en que sea exigible.
                                                    </li>
                                                    <li>
                                                        <strong>LFPDPPP:</strong> Ley Federal de Protección de Datos Personales en Posesión de Particulares. 
                                                    </li>
                                                    <li>
                                                        <strong>Pagaré:</strong> Documento mercantil que garantiza el cumplimiento de las obligaciones derivadas de la firma de este 
                                                        contrato y forma parte integrante como <strong>Anexo “C”</strong> 
                                                    </li>
                                                    <li>
                                                        <strong>Disposición de Recursos:</strong> Importe en pesos que <strong>GOLDBERGFUND</strong> autoriza le sea entregado mediante 
                                                        transferencia electrónica o cheque nominativo a <strong>EL ACREDITADO</strong>. 
                                                    </li>
                                                    <li>
                                                        <strong>Día Hábil:</strong> Días dispuestos por la Comisión Nacional Bancaria y de Valores para que las instituciones de crédito
                                                        presten los servicios al público.
                                                    </li>
                                                    <li>
                                                        <strong>Vehículo:</strong> Automóvil adquirido por <strong>EL ACREDITADO</strong> como objeto del presente contrato, cuya marca y modelo se 
                                                        encuentran en la caratula del presente contrato.
                                                    </li>
                                                    <li>
                                                        <strong>Garantía Prendaria:</strong> Vehículo adquirido por <strong>EL ACREDITADO</strong> como objeto del presente contrato, mismo que 
                                                        asegurara el cumplimiento de pago del presente contrato.
                                                    </li>
                                                    <li>
                                                        <strong>Entidad Financiera:</strong> Aquella agrupación que se dedica a ofrecer servicios financieros. Esta realiza actividades 
                                                        bancarias de intermediación financiera, seguros, inversión en valores y otros. <strong>Entidad Financiera:</strong> Aquella 
                                                        agrupación que se dedica a ofrecer servicios financieros. Esta realiza actividades bancarias de intermediación 
                                                        financiera, seguros, inversión en valores y otros. 
                                                    </li>
                                                </ol>
                                            </li>
                                            <li class="list-letter list-letter-normal mt-1">
                                                <span class="list-title">Que se reconocen mutuamente la personalidad con la que actúan.</span>
                                            </li>
                                            <li class="list-letter list-letter-normal">
                                                <span class="list-title">Que conocen el contenido y alcance legal del presente contrato manifestándose conformes con los derechos y 
                                                obligaciones incluidos y asumidos en el mismo.</span>
                                            </li>
                                            <li class="list-letter list-letter-normal">
                                                <span class="list-title">Que comparecen libremente a la firma del presente contrato sin vicios de la voluntad renunciando por tanto a la 
                                                interposición de cualquier acción fundamentada en vicios del consentimiento.</span>
                                            </li>
                                        </ol>
                                    </div>
                                    
                                    <p class="mt-1" style="margin-bottom: 0px !important;">
                                        <strong>
                                            Estando de acuerdo con las Declaraciones que anteceden GOLDBERGFUND, EL ACREDITADO Y EL OBLIGADO SOLIDARIO 
                                            convienen en sujetarse al tenor de las siguientes:
                                        </strong>
                                    </p>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 3 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <!-- Page 3 -->
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>

                                    <div class="section-title text-uppercase">CLÁUSULAS:</div>

                                    <div class="content-clausulas">
                                        <p>
                                            <strong>PRIMERA. ‐ GOLDBERGFUND</strong> pone a disposición de <strong>EL ACREDITADO</strong> el importe establecido en la carátula del presente 
                                            contrato, en cuyo monto no quedan comprendidos los intereses ordinarios, moratorios, seguros, comisiones, impuesto al 
                                            valor agregado, y en general ningún gasto que se cause en virtud de la firma de este contrato, los cuales deberán ser 
                                            cubiertos por <strong>EL ACREDITADO</strong> en la Fecha de Pago mencionados en el Anexo “B” de este contrato.
                                        </p>
                                        <p>
                                            La disposición del crédito solicitado por <strong>EL ACREDITADO</strong> será sujeto a una Comisión por Apertura, conforme al porcentaje 
                                            previsto en la carátula (Anexo A) del presente contrato, más el Impuesto al Valor Agregado correspondiente, mismo que 
                                            será descontado del importe total del crédito puesto a disposición de <strong>EL ACREDITADO</strong> a la fecha del presente contrato. 
                                        </p>
                                        <p>
                                            <strong>SEGUNDA. - EL ACREDITADO</strong> dispone del importe del crédito a partir de la fecha (colocar fecha), conforme a lo señalado 
                                            en el siguiente párrafo. Derivado de lo anterior, <strong>EL ACREDITADO</strong> reconoce y acepta que su firma en el presente contrato 
                                            constituye el recibo más amplio y eficaz que en derecho proceda. <strong>GOLDBERGFUND</strong> queda facultado para, sin estar 
                                            obligado, a emitir un documento en el que establezca los diferentes conceptos de aplicación del presente crédito, que 
                                            podrá referirse entre otros a comisiones, gastos y cualquier otro que describa, debiendo firmarlo <strong>EL ACREDITADO</strong> como 
                                            constancia de su plena conformidad. Sin embargo, si <strong>EL ACREDITADO</strong> se negara a firmar dicho documento, esto no le 
                                            restará fuerza legal, ni implicará la no conformidad de <strong>EL ACREDITADO</strong>. 
                                        </p>
                                        <p>
                                            En este acto <strong>EL ACREDITADO</strong> acusa de recibido, a partir de la fecha (colocar fecha), la cantidad de (colocar cantidad), 
                                            mencionada en la Carátula (Anexo A) del presente contrato, misma que se le entregará en una sola exhibición y después 
                                            de la firma del presente contrato conforme a lo señalado en la cláusula siguiente. 
                                        </p>
                                        <p>
                                            <strong>TERCERA. - EL ACREDITADO</strong> se obliga a pagar a <strong>GOLDBERGFUND</strong> a partir del mes siguiente al de la fecha de Disposición del 
                                            crédito señalado en el presente contrato, tanto el importe del crédito como los intereses que se generen mediante __ 
                                            pagos mensuales y consecutivos, cada uno de ellos por la cantidad de (colocar cantidad), pagos que se deberán efectuar 
                                            precisamente el día (colocar el día) de cada mes, siendo el primero de ellos el día (colocar el día). Dichos pagos se 
                                            encuentran listados y descritos en el presente contrato como ANEXO B. 
                                        </p>
                                        <p>
                                            <strong>CUARTA. ‐</strong> El importe otorgado a <strong>EL ACREDITADO</strong> en la carátula (Anexo A) del presente contrato, será destinado única y 
                                            exclusivamente para la adquisición de un vehículo automóvil de uso terrestre, nuevo o seminuevo. En caso de ser 
                                            seminuevo, el modelo no deberá tener una antigüedad de 3 (tres) años contados a la fecha de firma del presente contrato. 
                                        </p>
                                        <p>
                                            <strong>QUINTA. ‐</strong> Dentro de los 10 (diez) días hábiles siguientes a la fecha de celebración de este contrato, <strong>EL ACREDITADO</strong> tendrá 
                                            derecho a cancelar el presente contrato sin responsabilidad alguna para él, siempre y cuando: (i) <strong>EL ACREDITADO</strong> notifique 
                                            por escrito a <strong>GOLDBERGFUND</strong> dentro de dicho plazo, su deseo de cancelar este contrato; y (ii) <strong>EL ACREDITADO</strong> no haya 
                                            hecho disposición del recurso estipulado en la carátula (Anexo A) de este contrato. 
                                        </p>
                                        <p>
                                            <strong>SEXTA. ‐ EL ACREDITADO</strong> se obliga a contratar un seguro de vida y uno de desempleo con la compañía de seguros y 
                                            características especificadas en la carátula (Anexo A) del presente contrato. El seguro permanecerá vigente hasta la fecha 
                                            de terminación del contrato. 
                                        </p>
                                        <p>
                                            <strong>GOLDBERGFUND</strong> gestionará la contratación del seguro de vida y desempleo con un tercero independiente, entregando 
                                            dos ejemplares de la póliza de seguro, uno para <strong>GOLDBERGFUND</strong> y otro para <strong>EL ACREDITADO</strong>, la póliza deberá contener: 
                                            (i) La vigencia de los seguros por un plazo no menor al del presente contrato, (ii) El endoso de beneficiario preferente en 
                                            favor de <strong>GOLDBERGFUND</strong>, y (iii) La aceptación por parte de la aseguradora que tanto la póliza como el endoso, no podrán 
                                            ser cancelados, modificados, revocados o terminados, sin la autorización previa y por escrito de <strong>GOLDBERGFUND</strong>.
                                        </p>
                                        <p>
                                            El pago parcial de las primas de seguros contratadas por <strong>EL ACREDITADO</strong>, estarán incluidas en la tabla de amortización que 
                                            se muestra en el <strong>Anexo B</strong> del contrato, en el rubro de seguro de vida y seguro de desempleo según corresponda. 
                                        </p>
                                        <p>
                                            <strong>SÉPTIMA. ‐</strong> Adicional a lo establecido en la cláusula sexta que antecede, <strong>EL ACREDITADO</strong> se obliga a contratar y mantener, 
                                            durante toda la vigencia de este contrato, una póliza de seguro vehicular, la cual deberá contener:(i) Vigencia multianual 
                                            equivalente al plazo establecido en la carátula del presente contrato. (ii) Cobertura por daños materiales y robo total del 
                                            vehículo hasta por una cantidad equivalente al valor indicado en la factura del vehículo o al valor comercial al momento 
                                        </p>
                                    </div>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 4 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            de la contratación. (iii) Cobertura por responsabilidad civil que cubra los daños a terceros en sus bienes y/o en sus personas. 
                                            (iv) Cobertura sin limitación por temas de ubicación territorial dentro de la República Mexicana. (v) Endoso preferente e 
                                            irrevocable a favor de <strong>GOLDBERGFUND</strong>. (vi) La aceptación por parte de la aseguradora que tanto la póliza como el endoso, 
                                            no podrán ser cancelados, modificados, revocados o terminados, sin la autorización previa y por escrito de 
                                            <strong>GOLDBERGFUND</strong>. 
                                        </p>
                                        <p>
                                            El pago parcial de las primas de seguros contratadas por <strong>EL ACREDITADO</strong>, estarán incluidas en la tabla de amortización 
                                            (Anexo B) del presente contrato, bajo el rubro de seguro vehicular. 
                                        </p>
                                        <p>
                                            <strong>OCTAVA. - EL ACREDITADO</strong> se obliga a restituir a <strong>GOLDBERGFUND</strong> la cantidad otorgada, así como los intereses ordinarios, 
                                            intereses moratorios, seguros, comisiones y en general cualquier obligación de pago derivada del presente contrato, 
                                            conforme a los importes y en las fechas señaladas en la tabla de amortización descrita en el Anexo “B”, misma que, firmada 
                                            por las Partes, forma parte integrante de este contrato.
                                        </p>
                                        <p>
                                            Los pagos que <strong>EL ACREDITADO </strong> deba hacer a favor de <strong>GOLDBERGFUND</strong>, los realizará sin necesidad de gestión de cobro, en 
                                            pesos, en la fecha de su vencimiento o incluso antes, a través de los depósitos o transferencias bancarias en la institución 
                                            y número de cuenta señalados en la carátula del presente contrato (Anexo A).
                                        </p>
                                        <p>
                                            El pago se realizará en las fechas y por la cantidad indicada en el <strong>Anexo B</strong> de este Contrato. Cuando la fecha límite de pago 
                                            sea en un día inhábil esta se recorrerá al siguiente día hábil, sin que proceda el cobro de comisiones o intereses moratorios.
                                        </p>
                                        <p>
                                            Sin perjuicio de lo anterior, <strong>EL ACREDITADO</strong> autoriza expresamente a <strong>GOLDBERGFUND</strong>, mediante la suscripción del formato 
                                            de domiciliación de pago (Anexo D) que forma parte integrante de este contrato, para que cargue en la cuenta bancaria 
                                            que <strong>EL ACREDITADO</strong> señale, la cantidad indicada como <strong>“Pago para no Generar Interés”</strong> y/o cualquier otro concepto que, 
                                            con motivo de la falta de pago oportuno, se cause en términos del  presente contrato, estos últimos en cualquier fecha, 
                                            para lo cual autoriza a <strong>GOLDBERGFUND</strong>  para que realice el cargo domiciliado a dicha cuenta. 
                                        </p>
                                        <p>
                                            En todo momento <strong>EL ACREDITADO</strong> podrá solicitar la cancelación de la autorización otorgada en el párrafo que antecede 
                                            por medio de la presente cláusula sin costo a su cargo, en cuyo caso deberá efectuar el pago en términos del tercer párrafo 
                                            de esta cláusula. 
                                        </p>
                                        <p>
                                            En caso de que <strong>EL ACREDITADO</strong> tuviese alguna duda o requiera aclaración respecto de las cantidades reportadas como 
                                            saldos pendientes, los intereses cobrados o en general una diferencia en relación con la información proporcionada 
                                            respecto de su crédito, podrá presentar su solicitud de aclaración, la cual deberá ser resuelta por <strong>GOLDBERGFUND</strong> dentro 
                                            de un plazo máximo de 30 días hábiles posteriores a que se haya solicitado dicha aclaración. En caso de que 
                                            <strong>GOLDBERGFUND</strong> no dé respuesta dentro del plazo mencionado, se entenderá que los saldos pendientes, intereses, o 
                                            cualquier diferencia mencionados, han sido o serán cobrados correctamente por parte de <strong>GOLDBERGFUND</strong>.
                                        </p>
                                        <p>
                                            <strong>
                                                EL ACREDITADO deberá conservar las fichas de depósito o comprobantes de transferencia de los pagos que realice a 
                                                GOLDBERGFUND, para el caso de que no se reflejen en la contabilidad de GOLDBERGFUND. 
                                            </strong>
                                        </p>
                                        <p>
                                            <strong>NOVENA. - EL ACREDITADO</strong>se obliga a pagar puntualmente los impuestos, derechos y obligaciones que deban cubrirse 
                                            sobre el vehículo automotor, mientras permanezca en vigor este contrato y por tanto la garantía prendaria, autorizando a 
                                            <strong>GOLDBERGFUND</strong> para hacerlo por su cuenta en caso de incumplimiento por parte de <strong>EL ACREDITADO</strong>. En este último 
                                            supuesto, las cantidades pagadas por <strong>GOLDBERGFUND</strong> en nombre y por cuenta de <strong>EL ACREDITADO</strong> pasarán a formar parte 
                                            del crédito, incrementándose sin necesidad de firmar algún documento modificatorio, pagaré, solicitud, o cualquier otro 
                                            documento, por lo que bastará únicamente, la notificación por escrito por parte de <strong>GOLDBERGFUND</strong> en los términos 
                                            señalados en el presente contrato. 
                                        </p>
                                        <p>
                                            La autorización contenida en el párrafo anterior no exime de ninguna manera a <strong>EL ACREDITADO</strong> de la obligación de realizar 
                                            los citados pagos, ya que en ningún caso y en ninguna circunstancia será obligación de <strong>GOLDBERGFUND</strong> suplir dichas 
                                            obligaciones. Igualmente, esta autorización no implica renuncia de <strong>GOLDBERGFUND</strong> al derecho de dar por vencido 
                                            anticipadamente el plazo de este contrato por incumplimiento de <strong>EL ACREDITADO</strong>. 
                                        </p>
                                        <p>
                                            <strong>DÉCIMA. EL ACREDITADO</strong> reconoce y acepta para los efectos legales a que haya lugar, que los recursos con los que pagará
                                        </p>
                                    </div>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 5 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            el crédito, así como los costos y gastos, comisiones o cualquier accesorio del mismo, son y serán siempre propios y de 
                                            procedencia lícita. Asimismo, reconoce expresamente <strong>EL ACREDITADO</strong> que no actúa en nombre y representación de un 
                                            tercero. Igualmente, <strong>GOLDBERGFUND</strong> deberá de prevenir, detectar y reportar actos, omisiones u operaciones que 
                                            pudieran favorecer, auxiliar o cooperar para la comisión de actos delictivos, incluyendo de manera enunciativa y no 
                                            limitativa los delitos de lavado de dinero y terrorismo.
                                        </p>
                                        <p>
                                            En caso de que <strong>EL ACREDITADO</strong> haya hecho una declaración falsa, que conduzca al error o imprecisión, respecto de los 
                                            datos señalados en la presente cláusula, o en cualquiera de las cláusulas del mismo, de la carátula, y/o bien de los anexos, 
                                            significará que <strong>EL ACREDITADO</strong> ha incurrido en una causa de incumplimiento. A partir del momento en que se tenga 
                                            conocimiento de que <strong>EL ACREDITADO</strong> incurrió en un evento de incumplimiento, <strong>GOLDBERGFUND</strong> podrá cobrar 
                                            anticipadamente el monto del crédito restante, junto con los intereses, comisiones, y/o cualquier otro adeudo que se 
                                            derive del presente contrato. Sin perjuicio de que <strong>GOLDBERGFUND</strong> ejercite las acciones legales a las que tenga derecho 
                                            ante las autoridades competentes, derivado del incumplimiento de <strong>EL ACREDITADO</strong>.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA PRIMERA. ‐</strong> Salvo que <strong>GOLDBERFUND</strong> decida lo contrario, los pagos efectuados por <strong>EL ACREDITADO</strong> se aplicarán 
                                            en el siguiente orden: 1) impuestos, 2) intereses moratorios, 3) comisiones, 4) gastos, 5) intereses ordinarios y 6) capital.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA SEGUNDA. ‐ EL ACREDITADO</strong> se obliga a pagar a <strong>GOLDBERGFUND</strong> por el otorgamiento del crédito objeto del 
                                            presente contrato y sin necesidad de previo requerimiento, por concepto de intereses ordinarios, la tasa de interés anual 
                                            ordinaria establecida en la caratula (Anexo A) del presente contrato. Los intereses ordinarios se generarán desde la fecha 
                                            de celebración del presente contrato y hasta el pago total del importe otorgado.
                                        </p>
                                        <p>
                                            Los intereses ordinarios se calcularán con base a la siguiente fórmula:
                                        </p>
                                        <p>
                                            <strong>
                                                Tasa de interés anual / 360 = Tasa de interés diaria. 
                                                (Tasa de interés diaria * número de días efectivamente transcurridos) * Capital = Intereses Ordinarios. 
                                            </strong>>
                                        </p>
                                        <p>
                                            En caso de incumplimiento en el pago de las obligaciones en términos del presente contrato, EL ACREDITADO deberá pagar 
                                            por concepto de intereses moratorios sobre saldo insoluto computables desde la fecha del incumplimiento y hasta el pago 
                                            total del adeudo. El porcentaje de la tasa de interés moratoria es la que se establece en la carátula (Anexo A) del presente 
                                            contrato.
                                        </p>
                                        <p>
                                            Los intereses moratorios se calcularán con base a la siguiente formula:
                                        </p>
                                        <p>
                                            <strong>Tasa de interés anual moratoria fija / 360 = Tasa de interés diaria [% DIARIO]. 
                                            (Tasa de interés diaria * número de días efectivamente transcurridos) *Capital = Intereses Moratorios.</strong>
                                        </p>
                                        <p>
                                            En ningún caso los intereses moratorios serán exigidos por adelantado, sino únicamente por periodos vencidos.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA TERCERA. ‐ EL ACREDITADO,</strong> ppara garantizar el exacto y oportuno cumplimiento de todas y cada una de las 
                                            obligaciones a su cargo, derivadas del presente contrato, y de conformidad con el Título II, Capítulo IV, Sección VII de la Ley 
                                            General de Títulos y Operaciones de Crédito, por este acto manifiesta su conformidad para otorgar el vehículo mencionado 
                                            en la carátula del presente contrato, en garantía prendaria sin trasmisión de posesión. Con la finalidad de garantizar el 
                                            pago de todas las cantidades, incluyendo el capital, interés, comisiones y primas de seguros o cualquier cantidad adicional, 
                                            respecto de las obligaciones que deriven de la firma del presente contrato. 
                                        </p>
                                        <p>
                                            La prenda otorgada en garantía en este acto surte todos sus efectos legales a la firma del presente contrato, en esta fecha 
                                            <strong>EL ACREDITADO</strong> entrega a <strong>GOLDBERGFUND</strong>, la factura original del vehículo endosada y a favor de <strong>GOLDBERGFUND</strong>. La 
                                            factura permanecerá resguardada por <strong>GOLDBERGFUND</strong> en tanto permanezca vigente o no se liquiden las obligaciones de 
                                            pago originadas por el presente contrato. 
                                        </p>
                                        <p>
                                            Toda vez que el fin de la prenda es garantizar el cumplimiento exacto y puntual de todas y cada una de las obligaciones, en 
                                            el supuesto que <strong>EL ACREDITADO y EL OBLIGADO SOLIDARIO</strong>, en su caso, incumplan con cualquiera de sus obligaciones 
                                            conforme a este contrato, de conformidad con lo dispuesto en el Código de Comercio, se llevara a cabo el procedimiento 
                                            de ejecución establecido.
                                        </p>
                                    </div>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 6 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            <strong>DÉCIMA CUARTA. - EL ACREDITADO</strong> se obliga a mantener el vehículo automotor en buen estado de conservación y 
                                            funcionamiento, y a responder por los deterioros y desperfectos que sufra por el mal uso o negligencia; en el entendido 
                                            de que, durante la vigencia del presente contrato <strong>EL ACREDITADO</strong> se obliga a pagar oportunamente las multas, impuestos, 
                                            tenencias, y en general cualquier derecho u obligación vehicular ante las autoridades Municipales, Estatales o Federales, 
                                            según sea el caso. 
                                        </p>
                                        <p>
                                            Asimismo, <strong>EL ACREDITADO</strong> no podrá transferir la propiedad, titularidad y/o posesión de dicho vehículo automotor a un 
                                            tercero, bajo ninguna circunstancia. El incumplimiento a la presente cláusula dará lugar a la recisión del presente contrato 
                                            y facultará a <strong>GOLDBERGFUND</strong> a exigir el pago del crédito otorgado, más los intereses correspondientes y demás accesorios 
                                            que se deriven del presente contrato. 
                                        </p>
                                        <p>
                                            <strong>DÉCIMA QUINTA. ‐</strong> El presente contrato, con todas y cada una de sus obligaciones, surtirá sus efectos legales en la fecha 
                                            de su firma y concluirá en la fecha en que <strong>EL ACREDITADO</strong> restituya, a entera satisfacción de <strong>GOLDBERGFUND</strong> el monto 
                                            total de la cantidad que se señala en la carátula (Anexo A) de este contrato, más los intereses ordinarios, intereses 
                                            moratorios, seguros, comisiones y demás gastos generados por la celebración del presente contrato y de sus anexos, 
                                            incluyendo el contrato de prenda sin transmisión de posesión.
                                        </p>
                                        <p>
                                            <strong>DÉCIMA SEXTA. ‐ EL OBLIGADO SOLIDARIO</strong> que comparece a la celebración del presente contrato, se obliga solidaria e 
                                            incondicionalmente a realizar el pago puntual y oportuno de la suerte principal, intereses ordinarios, intereses moratorios, 
                                            seguros, comisiones y demás cantidades establecidas en el presente contrato, así como en cualquiera de sus anexos. Por 
                                            lo anterior, <strong>EL OBLIGADO SOLIDARIO</strong> deberá responder con todo su patrimonio presente o futuro, de las obligaciones de 
                                            <strong>EL ACREDITADO</strong>.
                                        </p>
                                        <p>
                                            Como consecuencia de lo anterior, <strong>GOLDBERGFUND</strong> podrá realizar el cobro de manera directa a <strong>EL OBLIGADO SOLIDARIO</strong> 
                                            de la suerte principal, intereses ordinarios, intereses moratorios, seguros, comisiones y demás cantidades establecidas en 
                                            el presente contrato, así como en cualquiera de sus anexos, ya sea de manera total o parcial, sin realizar primeramente el 
                                            cobro de dichas cantidades a <strong>EL ACREDITADO</strong>, ni agotar el cobro de las mismas en los bienes de <strong>EL ACREDITADO</strong>. 
                                        </p>
                                        <p>
                                            Por lo que, para efectos de lo establecido en esta cláusula, <strong>EL OBLIGADO SOLIDARIO</strong> renuncia expresamente a los beneficios 
                                            de Orden, excusión y división que establece el Código Civil vigente en Quintana Roo. 
                                        </p>
                                        <p>
                                            <strong>DÉCIMA SÉPTIMA. ‐ EL   ACREDITADO y   EL   OBLIGADO SOLIDARIO</strong>, manifiestan su consentimiento en firmar como 
                                            suscriptor y aval respectivamente, un título mercantil o Pagaré(s) por cada parcialidad conforme lo señalado en la Tabla de 
                                            Amortización (Anexo “B”) del presente contrato, el cual incluirá el importe de la suerte principal, los intereses ordinarios, 
                                            intereses moratorios, comisiones y seguros, a efecto de garantizar el cumplimiento de las obligaciones derivadas del 
                                            presente contrato. 
                                        </p>
                                        <p>
                                            Dichos Pagaré(s) formarán parte integrante del presente contrato como Anexo(s) “C” y quedarán a disposición de 
                                            <strong>GOLDBERGFUND</strong> y se irán devolviendo conforme se acredite el pago de cada uno de ellos, mediante la entrega de las fichas 
                                            de depósito o comprobantes de pago a que hace referencie el presente contrato. 
                                        </p>
                                        <p>
                                            <strong>DÉCIMA OCTAVA. ‐ EL ACREDITADO</strong> podrá liquidar anticipadamente su crédito sin cargo o comisión, para lo cual deberá 
                                            solicitarlo por escrito a <strong>GOLDBERGFUND</strong>. Una vez presentada la solicitud por parte de <strong>EL ACREDITADO, GOLDBERGFUND</strong> 
                                            le proporcionará un número de folio que identifique su solicitud. 
                                        </p>
                                        <p>
                                            <strong>DÉCIMA NOVENA. ‐ GOLDBERGFUND</strong> dará por terminado el contrato el día hábil siguiente a aquél en que reciban la 
                                            solicitud. Lo anterior operará únicamente en el caso que no existan adeudos a cargo de <strong>EL ACREDITADO</strong>, en caso contrario 
                                            <strong>GOLDBERGFUND</strong> se compromete a informar el saldo de liquidación a <strong>EL ACREDITADO</strong> dentro de los siguientes dos días 
                                            hábiles a su solicitud. Para la liquidación, <strong>EL ACREDITADO</strong> debe depositar el importe exacto en una sola exhibición en la 
                                            cuenta proporcionada por <strong>GOLDBERGFUND</strong>; una vez realizado el pago, se dará por terminado el contrato y 
                                            <strong>GOLDBERGFUND</strong> pondrá a disposición de <strong>EL ACREDITADO</strong> dentro de los treinta días hábiles siguientes al día del pago de la 
                                            liquidación, la carta finiquito correspondiente, cancelará y devolverá los pagarés por los pagos parciales que hubiesen sido 
                                            cubiertos anticipadamente por <strong>EL ACREDITADO</strong>. <strong>GOLDBERGFUND</strong> también reportará a las sociedades de información 
                                            crediticia que la cuenta está cerrada sin adeudo alguno. 
                                        </p>
                                        <p>
                                            En el supuesto de existir saldo a favor de <strong>EL ACREDITADO, GOLDBERGFUND</strong> depositará a la cuenta que le señale <strong>EL</strong> 
                                        </p>
                                    </div>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 7 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number" style="margin-bottom: 20px !important;">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            ACREDITADO por escrito, el saldo correspondiente. 
                                        </p>
                                        <p>
                                            Cuando la terminación del contrato sea por conducto de una <strong>ENTIDAD FINANCIERA</strong> esta liquidará el adeudo de EL 
                                            <strong>ACREDITADO</strong> de acuerdo con la información que proporcione <strong>GOLDBERGFUND</strong> y una vez cubiertos los adeudos a 
                                            <strong>GOLDBERGFUND</strong> este renunciará a todos los derechos de cobro remanente que pudiera subsistir después del momento 
                                            de la cancelación.
                                        </p>
                                        <p>
                                            Durante la vigencia del presente contrato, <strong>EL ACREDITADO</strong> podrá realizar pagos anticipados previa solicitud presentada a 
                                            <strong>GOLDBERGFUND</strong>, siempre y cuando esté al corriente de sus pagos exigibles, sean por una cantidad superior a dos 
                                            parcialidades y que haya realizado pagos exigibles puntuales por un periodo no menor a dos meses. El hecho de anticipar 
                                            pagos parciales no le exime a <strong>EL ACREDITADO</strong> de la obligación de efectuar el pago total del adeudo en las fechas previstas 
                                            en el Anexo “B” de este contrato. 
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO</strong> podrá efectuar, en cualquier tiempo, pagos anticipados en reembolso del crédito, los cuales se aplicarán 
                                            al pago del saldo insoluto en orden inverso al del vencimiento de las amortizaciones respectivas, es decir, se aplicarán a las 
                                            últimas amortizaciones/pagos que se vayan a vencer y tendrán efecto a partir del siguiente período al que se realicen, 
                                            tomando en cuenta lo previsto en la cláusula Décima Primera del presente contrato. 
                                        </p>
                                        <p>
                                            <strong>GOLDBERGFUND</strong> calculará el importe de los intereses por devengar, con base en el nuevo saldo insoluto, <strong>GOLDBERGFUND</strong> 
                                            y <strong>EL ACREDITADO</strong>, convienen en que los pagos anticipados reducirán exclusivamente el plazo de este contrato, por lo que 
                                            no variarán el monto de cada una de las amortizaciones señaladas en el presente contrato y sus anexos. Con independencia 
                                            de lo anterior, <strong>EL ACREDITADO</strong> podrá solicitar por escrito a <strong>GOLDBERGFUND</strong> que los pagos anticipados disminuyan el 
                                            monto de las amortizaciones a su cargo sin que se modifique el plazo remanente del crédito, caso en el cual las 
                                            amortizaciones variarán en términos de la nueva tabla de amortización que <strong>GOLDBERGFUND</strong> le proporcione a <strong>EL 
                                            ACREDITADO</strong>. En cualquier caso, <strong>GOLDBERGFUND</strong> deberá calcular el importe de los intereses por devengar con base en el 
                                            nuevo saldo insoluto y le hará entrega a <strong>EL ACREDITADO</strong> del comprobante correspondiente del pago anticipado. 
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA. ‐</strong> Las partes convienen expresamente que, si <strong>EL ACREDITADO</strong> dejare de cumplir con cualquiera de las 
                                            obligaciones a su cargo derivadas de este contrato, y sin necesidad de declaración judicial previa, <strong>GOLDBERGFUND</strong> podrá 
                                            dar por vencido anticipadamente el plazo para el pago de las obligaciones derivadas del presente contrato. En tal caso, 
                                            será exigible el pago del total del adeudo, que se encuentre pendiente de vencimiento, que incluye la suerte principal, más 
                                            los intereses que se hubiesen devengado a la fecha del incumplimiento, y demás accesorios.
                                        </p>
                                        <p style="margin-top: 4px !important; margin-bottom: 4px !important;">
                                            <strong>VIGÉSIMA PRIMERA. ‐</strong> Serán causa de rescisión de este contrato, los siguientes:
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="a" class="list-text custom-alpha">
                                                <li class="list-letter list-letter-normal">
                                                    En caso de que cualquiera de las declaraciones <strong>EL ACREDITADO</strong> contenidas en este contrato, sus anexos y la solicitud 
                                                    de crédito sea o resulte ser falsa o incorrecta; 
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    En caso de que cualquier dato o información de <strong>EL ACREDITADO</strong> que sea entregada o hecha del conocimiento de 
                                                    <strong>GOLDBERGFUND</strong> sea o resulte ser falsa o incorrecta; 
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    El incumplimiento de <strong>EL ACREDITADO</strong> a cualquiera de las obligaciones de hacer o de no hacer consignadas a su cargo 
                                                    en este contrato; 
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Si el importe otorgado fuera destinado a la consecución de cualquier acto ilícito o a cualquier otro acto distinto a la 
                                                    adquisición del vehículo automotor; 
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    La falta de pago por parte de <strong>EL ACREDITADO</strong> de dos o más parcialidades consecutivas.
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Si <strong>EL ACREDITADO</strong> hiciere cesión total o parcial del vehículo otorgado en garantía, en perjuicio de <strong>GOLDBERGFUND</strong>.
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    La muerte, insolvencia, o incapacidad sobrevenida del <strong>OBLIGADO SOLIDARIO</strong> o en su caso del aval de los pagarés 
                                                    referidos en el presente contrato, en caso de que sea una persona física; o bien la fusión, escisión, cambio de control 
                                                    derivado de una capitalización o transmisión de acciones o partes sociales, insolvencia, inicio de un concurso 
                                                    mercantil, disolución y liquidación, en este último caso si se trata de una sociedad mercantil. Lo anterior en el 
                                                    entendido de que <strong>EL ACREDITADO</strong> no haya obtenido la autorización de <strong>GOLDBERGFUND</strong> respecto del reemplazo o 
                                                    sustitución del <strong>OBLIGADO SOLIDARIO</strong> cuando se presente alguna de las circunstancias señaladas en el presente 
                                                    párrafo, dentro de los tres días hábiles siguientes a su acaecimiento.
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Si <strong>EL ACREDITADO</strong> no da el aviso correspondiente del cambio de domicilio a que se refiere la Cláusula Vigésima 
                                                    Novena del presente contrato. 
                                                </li>
                                            </ol>
                                        </div>
                                        <p class="mt-2" style="margin-bottom: 0px !important;">
                                            Ante la actualización de cualquiera de las causas de incumplimiento antes señalada, <strong>EL ACREDITADO</strong> estará obligado a 
                                            pagar a <strong>GOLDBERGFUND</strong> de manera inmediata el importe total del saldo insoluto del monto ejercido, que incluye los
                                        </p>
                                    </div>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 8 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number mt-1">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            intereses ordinarios vencidos, intereses moratorios, así como cualquier otro concepto devengado contractual o 
                                            legalmente, pago que deberá verificarse sin necesidad de presentación, requerimiento, protesto u otra notificación de 
                                            cualquier clase a EL ACREDITADO, a todas las cuales renuncia expresamente por el presente instrumento. 
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA SEGUNDA. ‐ EL ACREDITADO</strong> autoriza a <strong>GOLDBERGFUND a:</strong>
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="a" class="list-text custom-alpha">
                                                <li class="list-letter list-letter-normal">
                                                    Proporcionar y recabar información sobre operaciones crediticias y otras de naturaleza análoga que haya celebrado 
                                                    con <strong>GOLDBERGFUND</strong> a las sociedades de información crediticia, en términos de la autorización previamente 
                                                    otorgada. 
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Consultar su información en las Sociedades de Información Crediticia en forma previa al otorgamiento del presente 
                                                    contrato, autorización que se realizó mediante medios electrónicos. 
                                                </li>
                                            </ol>
                                        </div>
                                        <p class="mt-2">
                                            <strong>VIGÉSIMA TERCERA. ‐ EL ACREDITADO</strong> autoriza a <strong>GOLDBERGFUND</strong> para que:
                                        </p>
                                        <p>
                                            <strong>(i)</strong> solicite, consulte, obtenga y verifique, cuantas veces considere necesario cualquier información financiera y de historial 
                                            crediticio de cualquier sociedad de información crediticia en términos de la Ley Para Regular a las Sociedades de 
                                            Información Crediticia; <strong>(ii)</strong> recopile, procese, use y transfiera la información personal de <strong>EL ACREDITADO</strong> en Posesión de 
                                            los Particulares de conformidad con los términos y condiciones previstos en el aviso de privacidad de <strong>GOLDBERGFUND</strong> que 
                                            firmado por <strong>EL ACREDITADO</strong>, forma parte del presente contrato, mismo que se puso a su disposición y cuyo propósito es, 
                                            recopilar, usar y almacenar la información personal, comercial, financiera y de historial crediticio de <strong>EL ACREDITADO</strong> con 
                                            entidades nacionales e internacionales relacionadas con <strong>GOLDBERGFUND</strong> así como con prestadores de servicios, 
                                            incluyendo pero sin limitar a las agencias de cobranza con la finalidad de cumplir las obligaciones de <strong>GOLDBERGFUND</strong> de 
                                            conformidad con la LFPDPPP, del presente contrato. <strong>GOLDBERGFUND</strong> garantiza que la información personal de EL 
                                            ACREDITADO será tratada de conformidad con los términos y condiciones previstos en el aviso de privacidad. EL 
                                            ACREDITADO reconoce y acepta que <strong>GOLDBERGFUND</strong> tendrá el derecho para modificar el aviso de privacidad, según se 
                                            prevé en dicho aviso. Adicionalmente, <strong>EL ACREDITADO</strong> declara que el contenido de dicho aviso de privacidad fue puesto a 
                                            su disposición por <strong>GOLDBERGFUND</strong> con anterioridad a la fecha de firma del presente Contrato, por lo que <strong>EL ACREDITADO</strong> 
                                            confirma y ratifica, por este medio, que otorgó su consentimiento expreso con la finalidad de que <strong>GOLDBERGFUND</strong> pueda, 
                                            recopilar, usar, procesar y almacenar su información personal con anterioridad a la celebración del presente contrato de 
                                            conformidad con la LFPDPPP. Asimismo, <strong>EL ACREDITADO</strong> reconoce que el aviso de privacidad cumple con lo previsto por 
                                            el Artículo 16 de la LFPDPPP. 
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA CUARTA. ‐</strong> Cualquier modificación relacionada al presente contrato deberá realizarse por escrito, misma que 
                                            deberá celebrarse en un plazo mínimo de 10 días hábiles anteriores a la fecha en que pretende surta sus efectos; 
                                            requiriendo el consentimiento de ambas partes. La modificación a que hace referencia esta cláusula en ningún caso aplicará 
                                            para las tasas de interés ni nuevas comisiones. 
                                        </p>
                                        <p>
                                            Se entenderá que <strong>EL ACREDITADO</strong> otorga su consentimiento si en un plazo de 3 días hábiles posteriores a la notificación 
                                            que le haga <strong>GOLDBERGFUND</strong>, no presenta inconformidad alguna por escrito dirigido a <strong>GOLDBERGFUND</strong>, y en su caso 
                                            <strong>GOLDBERGFUND</strong> entregará un folio del número de inconformidad. 
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA QUINTA. ‐</strong> Una vez pagados a satisfacción de <strong>GOLDBERGFUND</strong> la suerte principal, intereses, comisiones, seguros 
                                            y gastos por parte de <strong>EL ACREDITADO</strong>, <strong>GOLDBERGFUND</strong> emitirá, dentro de los 30 (treinta) días hábiles siguientes a la 
                                            verificación del pago del monto ejercido, la carta finiquito que establezca la inexistencia de adeudos por parte de <strong>EL 
                                            ACREDITADO</strong>. A menos que se extienda dicha carta finiquito, no se entenderá que el presente contrato ha concluido, y que 
                                            las obligaciones de pago a cargo de <strong>EL ACREDITADO</strong> han sido satisfechas. Será responsabilidad de <strong>EL ACREDITADO</strong>, o en su 
                                            caso, de EL OBLIGADO SOLIDARIO solicitar y dar seguimiento con <strong>GOLDBERGFUND</strong> para la extensión de dicha carta 
                                            finiquito. 
                                        </p>
                                        <p>
                                            <strong>VIGÉSIMA SEXTA. ‐ EL ACREDITADO</strong> autoriza expresamente a <strong>GOLDBERGFUND</strong> para: 
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="I">
                                                <li>
                                                    Solicitar, obtener o verificar cuantas veces sea necesario, su información personal y capacidad de pago a través del 
                                                    sistema de calificación que mide la capacidad de pago y confiabilidad de las personas a través de su actividad en 
                                                    las redes sociales; 
                                                </li>
                                                <li>
                                                    Efectuar cualquier otra investigación.
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                 <!-- Page 9 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number mt-1">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            <strong>VIGÉSIMA SÉPTIMA. ‐ El ACREDITADO</strong> contará con un período de 90 (noventa) días naturales, contado a partir de la fecha 
                                            que dio origen la reclamación y/o inconformidad, para formular, por escrito firmado, cualquier solicitud de aclaración de 
                                            la información contenida en el mismo, ante el departamento de atención a clientes de <strong>GOLDBERGFUND</strong>. Cuyos datos de 
                                            localización y contacto se establecen en la cláusula vigésima quinta. Una vez que <strong>GOLDBERGFUND</strong> reciba cualquier solicitud 
                                            de aclaración que sea formulada por <strong>EL ACREDITADO</strong> conforme a lo establecido en este contrato, se tendrá un plazo de 
                                            hasta 45 (cuarenta y cinco) días naturales para entregar a <strong>EL ACREDITADO</strong> el dictamen correspondiente, junto con la 
                                            información y/o documentación considerada para su emisión, así como un informe detallado en el que se respondan los 
                                            hechos contenidos en la solicitud de aclaración. En caso de que, conforme a dicho dictamen, resulte procedente el cobro 
                                            del monto de que se trate, <strong>EL ACREDITADO</strong> deberá hacer el pago de la cantidad a su cargo, incluyendo los intereses 
                                            ordinarios. Dentro del plazo de 15 (quince) días naturales contado a partir de la entrega del dictamen, <strong>GOLDBERGFUND</strong> 
                                            pondrá a disposición de <strong>EL ACREDITADO</strong>, a través de su departamento de atención a clientes, el expediente generado por 
                                            la solicitud, con la integración de la información y documentación que deba obrar en su poder y que se relacione 
                                            directamente con la solicitud. 
                                        </p>
                                        <p>
                                            VIGÉSIMA OCTAVA. ‐ Para efectos de consulta, información y quejas EL ACREDITADO podrá contactar a:
                                        </p>
                                        <div class="list-declaration">
                                            <ol type="a" class="list-text custom-alpha">
                                                <li class="list-letter list-letter-normal">
                                                    El departamento de atención de atención a clientes, con domicilio en: Calle Robert Schumann, Número 4898, Colonia 
                                                    Lomas del Seminario, Zapopan, Jalisco, C.P 45038 al teléfono 33 10 01 04 14 en un horario de atención de 9:00 a 
                                                    18:30 horas, de lunes a viernes.  
                                                </li>
                                                <li class="list-letter list-letter-normal">
                                                    Calle 7 sur Lote 3, Manzana 29 Local 212 C.P. 77717, Colonia Playacar Fase II, Playa del Carmen, Solidaridad, Quintana 
                                                    Roo, en un horario de atención de 9:00 a 18:30 horas, de lunes a viernes, o a través del correo electrónico 
                                                    <a href="contacto@goldbergfund.com." target="_blank">contacto@goldbergfund.com.</a> 
                                                </li>
                                            </ol>
                                        </div>
                                        <p class="mt-2">
                                            <strong>VIGÉSIMA NOVENA. ‐ GOLDBERGFUND</strong>, <strong>EL ACREDITADO</strong> y <strong>EL OBLIGADO SOLIDARIO</strong> acuerdan que, para todos los efectos 
                                            legales que correspondan derivados de este contrato, todos los avisos y notificaciones que tuvieren que darse se deberán 
                                            entregar por escrito cuando se requiera constancia de los mismos dirigidos a la contraparte, o bien enviados mediante 
                                            carta por correo certificado o mediante servicios especializados de mensajería o fedatario público, en el domicilio 
                                            respectivo y sean recibidos por la parte a quien hayan sido dirigidos, por alguno de sus empleados o por quien se encuentre 
                                            en el domicilio.
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO</strong> y <strong>EL OBLIGADO SOLIDARIO</strong> señalan como su domicilio para los efectos de lo señalado en la carátula del 
                                            presente contrato.
                                        </p>
                                        <p>
                                            <strong>GOLDBERGFUND</strong>, <strong>EL ACREDITADO</strong> y <strong>EL OBLIGADO SOLIDARIO</strong> acuerdan que, en caso de que llegaren por cualquier motivo, 
                                            a mudarse del domicilio que indicaron en este contrato, deberán hacérselo saber a la otra parte con, por lo menos, 15 
                                            (quince) días naturales previos a la fecha del cambio respectivo, de lo contrario, la notificación, aviso o pago que efectúe 
                                            la contraparte, se entenderá legalmente hecha en el domicilio que se hubiese señalado en el presente contrato con la 
                                            persona que se encuentre en el mismo.
                                        </p>
                                        <p>
                                            <strong>TRIGÉSIMA. ‐ El ACREDITADO</strong> no podrá ceder o transmitir cualquier derecho u obligación que, en términos del contrato, 
                                            resulte a su favor o a su cargo sin la previa aprobación escrita de <strong>GOLDBERGFUND</strong>. 
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO</strong> autoriza expresamente a <strong>GOLDBERGFUND</strong> para que éste último pueda, endosar, ceder, transmitir, 
                                            descontar, transferir, negociar, afectar y/o gravar, en cualquier tiempo y, respectivamente, cualquier derecho que, en 
                                            términos del contrato, resulte a favor de <strong>GOLDBERGFUND</strong> y/o los derechos de crédito contenidos en el contrato, ya sea en 
                                            forma total o parcial. Lo establecido en el presente párrafo, aplicará, de igual forma, respecto a cualquier acreedor y/o 
                                            causahabiente subsecuente.
                                        </p>
                                        <p>
                                            <strong>TRIGÉSIMA PRIMERA. ‐</strong> Las Partes acuerdan y reconocen los alcances y términos del presente contrato, y <strong>EL ACREDITADO</strong>, 
                                            así como el <strong>OBLIGADO SOLIDARIO</strong> otorgan de forma indubitable e irrevocable su consentimiento.
                                        </p>
                                        <p>
                                            <strong>EL ACREDITADO</strong> y <strong>EL OBLIGADO SOLIDARIO</strong> manifiestan que es su voluntad obligarse con <strong>GOLDBERGFUND</strong> respecto del 
                                            cumplimiento de todas y cada una de las obligaciones a cargo de <strong>EL ACREDITADO</strong>, de conformidad con los términos y 
                                            condiciones del <strong>Contrato, Carátula y Anexos</strong>. Declarando bajo protesta de decir verdad que la información proporcionada 
                                            a <strong>GOLDBERGFUND</strong>, en este contrato, carátula y anexos son verdaderos. 
                                        </p>
                                    </div>
                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Page 10 -->
                <div class="paper-sheet">
                    <!-- Margen superior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-top margin-top-sheet"></div>
                    <div class="content-area">
                        <!-- Margen izquierdo (3 cm) -->
                        <div class="mg-sheet mg-sheet-left margin-left-sheet"></div>
                        <!-- Área de contenido principal -->
                        <div class="main-content">
                            <!-- Espacio para encabezado (1.25 cm) -->
                            <!-- <div class="header-space"></div> -->
                            <!-- Contenido editable/contrato -->
                            <slot>
                                <div class="contract-page">
                                    <div class="contract-header">
                                        <div class="contract-number mt-1">
                                            Número de Contrato: <input type="text" class="underline-input">
                                        </div>
                                    </div>
                                    <div class="content-clausulas">
                                        <p>
                                            <strong>TRIGÉSIMA SEGUNDA. ‐ GOLDBERGFUND, EL ACREDITADO y EL OBLIGADO SOLIDARIO</strong> convienen que para el conocimiento 
                                            de cualquier controversia que llegare a suscitarse con motivo de la interpretación o cumplimiento del presente contrato, 
                                            se someten a lo estipulado en la Ley General de Títulos y Operaciones de Crédito, el Código de Comercio, y a la jurisdicción 
                                            de los tribunales competentes de la ciudad de Cancún, Quintana Roo, renunciando expresamente al fuero o fueros que 
                                            pudieran corresponderles en razón de sus domicilios o vecindades presentes, futuros o bien por cualquier otra causa. 
                                        </p>
                                        <p>
                                            El presente contrato y cada uno sus anexos incluyendo la carátula, una vez leído por <strong>GOLDBERGFUND, EL ACREDITADO y 
                                            EL OBLIGADO SOLIDARIO</strong>, enterados y estando de acuerdo de su contenido y alcance legal, lo firman en dos tantos 
                                            (quedando un tanto y sus anexos en poder de cada una de las partes) en la ciudad de Cancún, Quintana Roo, el día (agregar 
                                            fecha). 
                                        </p>
                                    </div>

                                    <div class="content-firma">
                                        <div class="container-fluid">
                                            <div class="row">
                                                <div class="col-4 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            GOLDBERGFUND
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                        <div class="col-12 line-firma-bottom">
                                                            KVF GROUP, S.A. DE C.V.
                                                            Representante Legal.
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de Identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Número de Identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Domicilio:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            EL ACREDITADO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                        <div class="col-12 line-firma-bottom">
                                                            Nombre.
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma" style="margin-top: 71px;">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de Identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Número de Identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Domicilio:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-4 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            EL OBLIGADO SOLIDARIO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                        <div class="col-12 line-firma-bottom">
                                                            <p>Nombre / Razón Social.</p>
                                                            <p>Representante Legal.</p>
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma" style="margin-top: 18px;">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de Identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Número de Identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Domicilio:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row separate-firma">
                                                <div class="col-5 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            TESTIGO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma bottom-firma-testigo">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Nombre:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-5 square-firma">
                                                    <div class="row top-firma">
                                                        <div class="col-12">
                                                            TESTIGO
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="signature-line"></div>
                                                        </div>
                                                    </div>
                                                    <div class="row bottom-firma bottom-firma-testigo">
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Nombre:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>RFC:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="form-group">
                                                                <label>Tipo de identificación:</label>
                                                                <input type="text" class="form-control">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </slot>
                            <!-- Espacio para pie de página (1.25 cm) -->
                            <!-- <div class="footer-space"></div> -->
                        </div>
                        <!-- Margen derecho (3 cm) -->
                        <div class="mg-sheet mg-sheet-right margin-right-sheet"></div>
                    </div>
                    <!-- Margen inferior (2.5 cm) -->
                    <div class="mg-sheet mg-sheet-bottom margin-bottom-sheet"></div>
                </div>

                <!-- Botón de descarga -->
                <div class="form-actions">
                    <button class="download-btn">Descargar PDF</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { useContractStore } from '@/pinia/LoanApplications/Legal/useContractStore.module';

const store = useContractStore();
const contractContent = ref(null);

// Acceder a la instancia de la app
const app = getCurrentInstance();

const handleSubmit = () => {
    store.saveData();
};

onMounted(() => {
    store.setContractContent(contractContent.value);
});
</script>

<style scoped>
/* Conversión a píxeles (96 DPI) */
/* :root {
    --dpi: 96;
    --cm-to-px: calc(var(--dpi) / 2.54);
} */

.page-simulator {
    /*background-color: #f5f5f5;
    padding: 20px;*/
    /*display: flex;*/
    /*justify-content: center;*/
    /*box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);*/
}

.paper-sheet {
    /* width: calc(21.59cm * var(--cm-to-px));
    height: calc(27.94cm * var(--cm-to-px)); */
    background-color: white;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    position: relative;
    display: flex;
    flex-direction: column;
}

.paper-sheet.pdf-mode {
    /*width: 793px;
    height: 1122px;
    overflow: hidden;
    padding: 95px 113px;
    box-sizing: border-box;*/
}

/* Márgenes principales */
.margin-top-sheet,
.margin-bottom-sheet {
    /*height: calc(2.5cm * var(--cm-to-px));
    border-bottom: 1px dashed #ccc;*/
    /*height: calc(2.5cm * var(--cm-to-px));
    border-top: 1px dashed #ccc;*/
    margin-top: 95px;
}

.margin-left-sheet,
.margin-right-sheet {
    /*width: calc(3cm * var(--cm-to-px));
    border-right: 1px dashed #ccc;*/
    /*width: calc(3cm * var(--cm-to-px));
    border-left: 1px dashed #ccc;*/
    /*margin-left: 113px;*/
    margin-left: 131px;
}

.content-area {
    display: flex;
    flex: 1;
}

.main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 10px;
}

/* Encabezado y pie de página */
/* .header-space {
    height: calc(1.25cm * var(--cm-to-px));
    border-bottom: 1px dotted #ddd;
}

.footer-space {
    height: calc(1.25cm * var(--cm-to-px));
    border-top: 1px dotted #ddd;
    margin-top: auto;
} */

/* Visualización de medidas (opcional) */
/* .margin-top::after,
.margin-bottom::after,
.margin-left::after,
.margin-right::after {
    content: attr(data-size);
    position: absolute;
    color: #999;
    font-size: 10px;
} */

.margin-top::after {
    bottom: 2px;
    right: 5px;
}

/* .margin-bottom::after {
    top: 2px;
    right: 5px;
} */

.margin-left::after {
    top: 5px;
    right: 2px;
    transform: rotate(90deg);
    transform-origin: right top;
}

.margin-right::after {
    top: 5px;
    left: 2px;
    transform: rotate(-90deg);
    transform-origin: left top;
}


.contract-container {
    /*width: 100%;
    margin: 0 auto;*/
    /**    max-width: 780px; */
    margin: 0px;
    padding: 0px;
}

.content-ref {
    margin: 0px;
    padding: 0px;
}

.contract-page {
    font-family: "Calibri Light", Calibri, "Gill Sans", "Gill Sans MT", sans-serif;
}

.contract-page p {
    margin-bottom: 12px;
}

.contract-number {
    text-align: right;
    margin-bottom: 25px;
    /*margin-bottom: 40px;*/
}

.contract-title p {
    text-align: justify;
}

.text-uppercase {
    text-transform: uppercase;
}

.underline-input {
    border: none;
    border-bottom: 1px solid #000;
    background: transparent;
    font-family: Arial, sans-serif;
    /*margin-right: 8px;*/
}

.underline-input-sm {
    width: 12%;
}

.underline-input-md {
    width: 25%;
}

.underline-input-lg {
    width: 50%;
}

.underline-input-xl {
    width: 100%;
}

.underline-input:focus,
.underline-input-sm:focus,
.underline-input-md:focus,
.underline-input-lg:focus,
.underline-input-xl:focus {
    outline: none;
    border-bottom: 2px solid #f8a845;
}

.section-title {
    font-weight: bold;
    margin: 15px 0 15px 0;
    text-transform: uppercase;
    text-decoration: underline;
    justify-self: center;
}

.declaration-item {
    margin-left: 18px;
}

.title-clausula-exception {
    margin-bottom: 15px;
}

.title-clausula {
    margin-bottom: 15px;
    margin-top: 15px;
}

/*.space-declaration {
    margin-left: 6px;
}*/

.space-letter {
    margin-right: 14px;
}

.list-declaration {
    /*margin-left: 11px;*/
    /*margin-left: 6px;*/
}

.list-declaration li {
    /*padding-left: 14px;*/
    padding-left: 10px;
}


/**Descargar */
.pdf-mode {
    font-size: 12px !important;
    /*line-height: 1.2;*/
}

.pdf-mode * {
    font-size: 12px !important;
    /*line-height: 1.2;*/
}


/** Formato de iniciso */
ol.list-text.custom-alpha {
    margin-bottom: 0;
}


ol.list-text.custom-alpha.custom-alpha-position {
    counter-reset: alpha-list 3; /* Empieza desde d (a=1, b=2, c=3, d=4) */
}

ol.custom-alpha {
    list-style-type: none;
    counter-reset: alpha-list;
}

ol.custom-alpha li.list-letter, ol.custom-alpha li.list-letter-normal {
    counter-increment: alpha-list;
    font-weight: bold;
    position: relative;
    margin-left: 0;
    padding-left: 0;
}

ol.custom-alpha li.list-letter::before, ol.custom-alpha li.list-letter-normal::before {
    content: counter(alpha-list, lower-alpha) ") ";
    font-weight: bold;
    position: absolute;
    left: -2em;  /*Ajusta para posicionar el marcador*/
    width: 2em;
    text-align: left;
}

ol.custom-alpha li.list-letter-normal {
    font-weight: normal !important;
}

ol.custom-alpha li.list-letter-normal::before {
    font-weight: normal !important;
}

/**Formato list */
.title-clausula-list {
    margin-bottom: 15px;
    margin-top: 15px;
}

.list-declaration {
    /*margin-left: -47px;*/
    margin-left: -5px;
}

.list-letter, .list-letter-normal {
    padding-left: 12px
}

span.list-title {
    font-weight: normal !important;
    /*margin-left: 10px;*/
}

ol.custom-number {
    font-weight: normal;
    /*margin-left: 6px;*/
    margin-left: -26px;
}

.content-clausulas {
    margin: 0px;
    padding: 0px;
}

ol.custom-number li, .content-clausulas p {
    text-align: justify;
}

/**Estilos firmas */
.content-firma{
    /*margin-left: -10px;
    margin-right: -10px;*/
    /* width: calc(100% + 50mm);
    transform: translateX(-25mm); */
    /* width: calc(100% + 35mm);
    transform: translateX(-15mm); */
    /* position: relative;
    transform: translateX(-2mm); */
    /*margin-left: -60px;
    margin-right: -60px;*/
    margin-left: -10px;
    margin-right: -10px;
}

/* Estilo para la sección de firmas en modo normal */
/*.content-firma {
    margin-left: -10px;
    margin-right: -10px;
}*/

/* .pdf-mode .content-firma {
    margin-left: -20px !important;    Extiende 20px hacia la izquierda /
    margin-right: -20px !important;     Extiende 20px hacia la derecha
    width: calc(100% + 40px) !important; Compensa el ancho con los márgenes negativos 
} */

.square-firma {
    border: 1px solid black;
    font-weight: bold;
}

.top-firma {
    text-align: center;
    /*min-height: 40%;*/
    /*min-height: 47%;*/
}

.signature-line{
    margin-top: 70px;
    border-bottom: 1px solid black;
    margin-right: 25px;
    margin-left: 25px;
}

.line-firma-bottom {
    /* margin-bottom: 70px; */
    /*margin-bottom: 50px;*/
}

.bottom-firma {
    margin-top: 50px;
    margin-bottom: 25px;
}

.bottom-firma .form-group {
    display: flex;
}

.bottom-firma-testigo {
    margin-top: 15px;
}

.bottom-firma input {
    flex: 1;
    background: transparent;
    border: none;
    border-bottom: 1px solid #000;
    border-radius: 0px;
    /* margin-left: 8px;
    margin-bottom: 5px;
    padding-bottom: -10px; */
    padding: 0px;
    height: auto;
    margin-left: 8px;
    /*width: 30%;*/
}

.bottom-firma input:focus {
    outline: none;
    border-bottom: 2px solid #f8a845;
}

.separate-firma{
    margin-top: 50px;
    justify-content: space-around;
}

.separate-firm .top-firma{
    /*min-height: 40%;*/
}


@media print {
    /* .single-page-mode {
        zoom: 0.20; Ajuste fino para que quepa en una página .82 
    } */

    /* .contract-page {
      page-break-after: always; Fuerza un salto después de cada página 
    } */

   /*  .paper-sheet{
         page-break-after: always !important; Fuerza un salto después de cada página
    } */


    /* Forzar cada hoja en nueva página */
    .paper-sheet {
        page-break-after: always !important;
        page-break-inside: avoid !important;
        /* height: 1122px;  Altura A4 */
        /*page-break-after: always !important;*/
        /*page-break-inside: avoid !important;*/
       /*  height: 1122px; Altura exacta de A4 en pixels (297mm) 
        overflow: hidden;*/
    }

    /* .contract-page, .declaration-item {
    page-break-inside: avoid !important;
  }  */

    /* Asegurar que el contenido no se divida
    .contract-page, .declaration-item, .list-declaration, .content-clausulas p {
        page-break-inside: avoid !important;
    }*/

    /* Control específico para números de contrato 
    .contract-number {
        page-break-before: always !important;
    }*/

    /* Resetear márgenes para impresión */
    .page-simulator {
        background: none;
        padding: 0;
    }

    .paper-sheet {
        box-shadow: none;
        margin: 0;
        width: 100%;
        height: auto;
    }

    [class*="margin-"] {
        border: none !important;
    }

    /* .paper-sheet{
        page-break-after: always !important;
    }

    .contract-page {
        page-break-inside: avoid !important;
    }

    .contract-number {
        page-break-before: always !important; 
    } */
}
</style>